var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"multi-line":"","top":""},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('v-btn',{attrs:{"dark":"","text":""},on:{"click":_vm.close}},[_c('v-icon',[_vm._v("mdi-close-circle")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }